// In-memory composer drafts keyed by conversation id; lost on a page refresh.
const drafts = new Map<string, string>();

export function getComposerDraft(conversationId: string | undefined): string {
  if (!conversationId) {
    return "";
  }
  return drafts.get(conversationId) ?? "";
}

export function setComposerDraft(conversationId: string | undefined, text: string): void {
  if (!conversationId) {
    return;
  }
  if (text) {
    drafts.set(conversationId, text);
  } else {
    drafts.delete(conversationId);
  }
}
